/**
 * Princess Eden - Quick View Module
 * Handles quick view button clicks, fetches product data, and displays in modal
 */
(function () {
  'use strict';

  var modal = null;
  var overlay = null;
  var content = null;
  var closeBtn = null;

  function init() {
    modal = document.getElementById('pe-quick-view-modal');
    if (!modal) return;
    overlay = modal.querySelector('.pe-quick-view-overlay');
    content = modal.querySelector('.pe-qv-content-inner');
    closeBtn = modal.querySelector('.pe-quick-view-close');

    // Delegate clicks for quick view buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pe-quick-view-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        openQuickView(btn.getAttribute('data-product-handle'));
      }
    });

    // Close handlers
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal();
    });
  }

  function openQuickView(handle) {
    if (!handle || !modal || !content) return;

    // Show loading
    content.innerHTML = '<div class="pe-qv-loading"><div class="pe-qv-spinner"></div></div>';
    modal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';

    // Fetch product data via Shopify AJAX API
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        renderModal(product);
      })
      .catch(function (err) {
        content.innerHTML = '<div style="padding:40px;text-align:center;color:#9a8a7e;">Failed to load product. Please try again.</div>';
        console.error('Quick View error:', err);
      });
  }

  function renderModal(product) {
    // Build variant options HTML
    var variantHTML = '';
    if (product.variants && product.variants.length > 1) {
      // Group by option
      for (var i = 0; i < product.options.length; i++) {
        var opt = product.options[i];
        var optName = opt.name || opt;
        var values = {};
        for (var j = 0; j < product.variants.length; j++) {
          var val = product.variants[j]['option' + (i + 1)];
          values[val] = true;
        }
        var uniqueValues = Object.keys(values).filter(function(v){ return v; });
        if (uniqueValues.length > 1 || optName.toLowerCase().indexOf('color') > -1 || optName.toLowerCase().indexOf('size') > -1) {
          variantHTML += '<div class="pe-qv-variants" style="margin-bottom:12px;">';
          variantHTML += '<label>' + escapeHtml(optName) + '</label>';
          variantHTML += '<select class="pe-qv-variant-select" data-option-index="' + i + '">';
          for (var k = 0; k < uniqueValues.length; k++) {
            variantHTML += '<option value="' + escapeAttr(uniqueValues[k]) + '">' + escapeHtml(uniqueValues[k]) + '</option>';
          }
          variantHTML += '</select>';
          variantHTML += '</div>';
        }
      }
    }

    // Price HTML
    var priceHTML = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      var discount = Math.round((1 - product.price / product.compare_at_price) * 100);
      priceHTML = '<div class="pe-qv-price">' + formatMoney(product.price) +
        '<s>' + formatMoney(product.compare_at_price) + '</s>' +
        '<span class="pe-qv-sale-badge">Save ' + discount + '%</span></div>';
    } else {
      priceHTML = '<div class="pe-qv-price">' + formatMoney(product.price) + '</div>';
    }

    // Image HTML
    var imageHTML = '';
    if (product.featured_image) {
      var imgUrl = product.featured_image;
      if (imgUrl.indexOf('http') !== 0) {
        imgUrl = 'https:' + imgUrl;
      }
      // Get larger version
      imgUrl = imgUrl.replace('_small.', '_600x600.');
      imgUrl = imgUrl.replace('_medium.', '_600x600.');
      imgUrl = imgUrl.replace('_large.', '_600x600.');
      imageHTML = '<img src="' + imgUrl + '" alt="' + escapeAttr(product.title) + '" loading="eager">';
    } else {
      imageHTML = '<div style="min-height:300px;display:flex;align-items:center;justify-content:center;color:#ccc;">No image</div>';
    }

    // Description (strip HTML)
    var desc = product.description ? product.description.replace(/<[^>]*>/g, '').slice(0, 200) : '';

    // Rating HTML
    var ratingHTML = '';
    if (product.rating) {
      ratingHTML = '<div class="pe-qv-rating">' +
        buildStars(product.rating) +
        '<span>(' + (product.review_count || 0) + ' reviews)</span></div>';
    }

    var html = '<div class="pe-qv-media">' + imageHTML + '</div>' +
      '<div class="pe-qv-info">' +
      '<div class="pe-qv-vendor">' + escapeHtml(product.vendor || 'Princess Eden') + '</div>' +
      '<h3 class="pe-qv-title">' + escapeHtml(product.title) + '</h3>' +
      ratingHTML +
      priceHTML +
      (desc ? '<div class="pe-qv-desc">' + escapeHtml(desc) + '...</div>' : '') +
      variantHTML +
      '<input type="hidden" class="pe-qv-variant-id" value="' + getFirstAvailableVariant(product).id + '">' +
      '<button class="pe-qv-add-cart" data-product-id="' + product.id + '">Add to Cart</button>' +
      '<a class="pe-qv-view-full" href="/products/' + product.handle + '">View Full Details</a>' +
      '</div>';

    content.innerHTML = html;

    // Set up variant selection
    setupVariantSelection(product);

    // Set up add to cart
    var addBtn = content.querySelector('.pe-qv-add-cart');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addToCart(product);
      });
    }
  }

  function setupVariantSelection(product) {
    var selects = content.querySelectorAll('.pe-qv-variant-select');
    if (selects.length === 0) return;

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateVariant(product);
      });
    });
  }

  function updateVariant(product) {
    var selects = content.querySelectorAll('.pe-qv-variant-select');
    var selectedValues = [];
    for (var i = 0; i < selects.length; i++) {
      selectedValues.push(selects[i].value);
    }

    // Find matching variant
    var matched = null;
    for (var j = 0; j < product.variants.length; j++) {
      var v = product.variants[j];
      var match = true;
      for (var k = 0; k < product.options.length; k++) {
        if (v['option' + (k + 1)] !== selectedValues[k]) {
          match = false;
          break;
        }
      }
      if (match) {
        matched = v;
        break;
      }
    }

    if (matched) {
      var idInput = content.querySelector('.pe-qv-variant-id');
      if (idInput) idInput.value = matched.id;

      // Update price
      var priceDiv = content.querySelector('.pe-qv-price');
      if (priceDiv) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          var discount = Math.round((1 - matched.price / matched.compare_at_price) * 100);
          priceDiv.innerHTML = formatMoney(matched.price) +
            '<s>' + formatMoney(matched.compare_at_price) + '</s>' +
            '<span class="pe-qv-sale-badge">Save ' + discount + '%</span>';
        } else {
          priceDiv.innerHTML = formatMoney(matched.price);
        }
      }

      // Update image
      if (matched.featured_image && matched.featured_image.src) {
        var img = content.querySelector('.pe-qv-media img');
        if (img) {
          var src = matched.featured_image.src;
          if (src.indexOf('http') !== 0) src = 'https:' + src;
          src = src.replace('_small.', '_600x600.').replace('_medium.', '_600x600.').replace('_large.', '_600x600.');
          img.src = src;
        }
      }

      // Update add to cart button
      var addBtn = content.querySelector('.pe-qv-add-cart');
      if (addBtn) {
        if (matched.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
    }
  }

  function addToCart(product) {
    var idInput = content.querySelector('.pe-qv-variant-id');
    if (!idInput) return;
    var variantId = idInput.value;
    var addBtn = content.querySelector('.pe-qv-add-cart');

    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (addBtn) {
          addBtn.textContent = 'Added!';
          addBtn.style.background = '#6f9c6b';
        }
        // Trigger cart drawer/refresh
        if (window.fetchCartDrawer) {
          window.fetchCartDrawer();
        }
        // Dispatch event for theme to pick up
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { product: product } }));
        // Also try the theme's cart update
        if (typeof fetchCart === 'function') {
          fetchCart();
        }
        setTimeout(function () {
          closeModal();
          if (addBtn) {
            addBtn.textContent = 'Add to Cart';
            addBtn.style.background = '';
            addBtn.disabled = false;
          }
        }, 1200);
      })
      .catch(function (err) {
        if (addBtn) {
          addBtn.textContent = 'Error - Try Again';
          addBtn.disabled = false;
        }
        console.error('Add to cart error:', err);
      });
  }

  function closeModal() {
    if (modal) modal.removeAttribute('open');
    document.body.style.overflow = '';
  }

  function getFirstAvailableVariant(product) {
    if (!product.variants || product.variants.length === 0) return { id: 0 };
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function formatMoney(cents) {
    var amount = typeof cents === 'string' ? parseFloat(cents) : cents;
    amount = amount / 100;
    return '$' + amount.toFixed(2);
  }

  function buildStars(rating) {
    var stars = '';
    var r = parseFloat(rating);
    for (var i = 1; i <= 5; i++) {
      stars += i <= r ? '\u2605' : '\u2606';
    }
    return '<span style="color:#e8a838;font-size:16px;">' + stars + '</span>';
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    if (!str) return '';
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
